import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const TreeRoot = ({ maxHeight, children }) => {
    const treeRootClasses = classNames('TreeRoot', 'user-select-none');
    return (_jsx("div", Object.assign({ className: treeRootClasses, style: { maxHeight: maxHeight } }, { children: children })));
};
TreeRoot.displayName = 'TreeRoot';
TreeRoot.propTypes = {
    maxHeight: PropTypes.number,
};
export default TreeRoot;
